import {
  ITINERARY_HEIGHT_MODE,
  ITINERARY_HEIGHT_MODE_CONDITIONS,
  ItineraryHeightModeType,
} from '@/app/ui/trip/client-trip-page';
import { useState, useMemo, useEffect } from 'react';

export default function useItineraryHeight(isEditRole: boolean) {
  const [itineraryHeightMode, setItineraryHeightMode] = useState<ItineraryHeightModeType>(
    ITINERARY_HEIGHT_MODE.DEFAULT,
  );

  const getInitialWindowHeight = () => {
    return typeof window !== 'undefined' ? window.innerHeight : 0;
  };

  const [windowInnerHeight, setWindowInnerHeight] = useState(getInitialWindowHeight());

  useEffect(() => {
    const handleResize = () => {
      setWindowInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const itineraryHeightValues = useMemo(() => {
    let sab = 0;
    const sabString =
      typeof getComputedStyle !== 'undefined'
        ? getComputedStyle(document.documentElement).getPropertyValue('--sab')
        : '';
    if (sabString.endsWith('px')) {
      sab = parseInt(sabString.replace('px', ''));
    }

    const ssrFullHeight = `calc(-${56 + (isEditRole ? 76 : 10)}px + 100dvh)`;
    const ssrDefaultHeight = `calc(-292px + 100dvh)`;

    if (windowInnerHeight === 0) {
      return {
        full: ssrFullHeight,
        default: ssrDefaultHeight,
        minimalize: `${48 + sab}px`,
      };
    } else {
      return {
        full: `${windowInnerHeight - 56 - (isEditRole ? 76 : 10)}px`,
        default: `${windowInnerHeight - 292}px`,
        minimalize: `${48 + sab}px`,
      };
    }
  }, [isEditRole, windowInnerHeight]);

  useEffect(() => {
    const $itinerary = document.getElementById('planner-itinerary');
    if (ITINERARY_HEIGHT_MODE_CONDITIONS.IS_FULL(itineraryHeightMode)) {
      $itinerary?.style.setProperty('height', `${itineraryHeightValues.full}`);
    } else if (ITINERARY_HEIGHT_MODE_CONDITIONS.IS_DEFAULT(itineraryHeightMode)) {
      $itinerary?.style.setProperty('height', `${itineraryHeightValues.default}`);
    } else {
      let sab = 0;
      const sabString =
        typeof getComputedStyle !== 'undefined'
          ? getComputedStyle(document.documentElement).getPropertyValue('--sab')
          : '';
      if (sabString.endsWith('px')) {
        sab = parseInt(sabString.replace('px', ''));
      }
      $itinerary?.style.setProperty('height', `${48 + sab}px`);
    }
  }, [itineraryHeightMode, itineraryHeightValues]);

  return {
    itineraryHeightMode,
    setItineraryHeightMode,
    itineraryHeightValues,
    windowInnerHeight,
  };
}
